import { RemoteConfigService } from '@web_opxp/features';
import ENV from '../base/env';

const DEFAULT_RESTORE_SUBSCRIPTION_PRODUCTS = '100';

export function canProductBeRestored(productId: number) {
  const productsString =
    RemoteConfigService.getStringConfigValue(
      ENV.RestoreSubscriptionRemoteConfig,
      DEFAULT_RESTORE_SUBSCRIPTION_PRODUCTS
    ) || '';
  const restorableProducts: number[] = productsString.split(',').map((value) => Number(value));
  return restorableProducts.includes(productId);
}
